export interface ContactInformationData {
  phoneNumber: string;
  email: string;
  emergencyContact: {
    name: string;
    relationship: string;
    phoneNumber: string;
    email: string;
  };
}

export interface ValidationResult {
  isValid: boolean;
  errorMessage?: string;
}

export function validateContactInformation(data: ContactInformationData): ValidationResult {
  // Validate required fields: phoneNumber and email
  if (!data.phoneNumber || data.phoneNumber.trim() === '') {
    return {
      isValid: false,
      errorMessage: 'Phone number is required',
    };
  }

  if (!data.email || data.email.trim() === '') {
    return {
      isValid: false,
      errorMessage: 'Email is required',
    };
  }

  // Check if any emergency contact field is filled
  const emergencyContactFields = [
    data.emergencyContact.name,
    data.emergencyContact.relationship,
    data.emergencyContact.phoneNumber,
    data.emergencyContact.email,
  ];

  const filledFields = emergencyContactFields.filter((field) => field && field.trim() !== '');

  // If some (but not all) emergency contact fields are filled, validation fails
  if (filledFields.length > 0 && filledFields.length < emergencyContactFields.length) {
    return {
      isValid: false,
      errorMessage: 'All emergency contact fields must be filled if any field is provided',
    };
  }

  // All validations passed
  return {
    isValid: true,
  };
}
